import { useState } from "react";

import { classNames } from "primereact/utils";

export default function ModuleExpandIcon({ handleExpand }) {
  const [isExpand, setIsExpand] = useState(false);

  return (
    <>
      <span
        className="mr-2"
        onClick={() => {
          setIsExpand(!isExpand);
          handleExpand();
        }}
      >
        <i
          className={classNames(
            "pi text-xs font-bold px-1 cursor-pointer transition-colors transition-duration-200 transition-ease-in-out ",
            {
              "pi-plus text-blue-400 hover:text-blue-200": !isExpand,
              "pi-minus text-red-400 hover:text-red-200": isExpand,
            }
          )}
        ></i>
      </span>
    </>
  );
}
